import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import EmployerSidebar, { ChevronDownIcon } from './EmployerSidebar';

// Category icons for the 3 report cards
const HiringIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
    <line x1="12" y1="20" x2="12" y2="10" />
    <line x1="18" y1="20" x2="18" y2="4" />
    <line x1="6" y1="20" x2="6" y2="16" />
  </svg>
);

const JobIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </svg>
);

const CandidateIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const reportCards = [
  {
    title: 'Hiring Analytics',
    description: 'Jobs created, applications, interviews, offers, hires, and joining ratio.',
    icon: <HiringIcon />,
    to: '/analytics/hiring',
    color: 'bg-purple-50 text-[#7C3AED]',
  },
  {
    title: 'Job Analytics',
    description: 'Performance breakdown for each job posting — views, applies, conversion.',
    icon: <JobIcon />,
    to: '/analytics/job',
    color: 'bg-pink-50 text-[#DB2777]',
  },
  {
    title: 'Candidate Analytics',
    description: 'Candidate pipeline trends, source quality, and match score insights.',
    icon: <CandidateIcon />,
    to: '/analytics/candidates',
    color: 'bg-violet-50 text-[#5B2EFF]',
  },
];

function EmployerReports() {
  const [user] = useState(() => {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  });

  const [showFiltersMobile, setShowFiltersMobile] = useState(false);

  return (
      <div className="min-h-screen bg-[#FDF8FF]">
      <Navbar user={user} />

      <div className="flex">
        <EmployerSidebar user={user} activeTab="reports" />

       <div className="flex-1 min-w-0 lg:ml-16 lg:peer-hover:ml-64 transition-all duration-200 ease-in-out">
          <div className="max-w-6xl mx-auto px-4 py-6">
            {/* Mobile-only: nav drawer */}
            <button
              onClick={() => setShowFiltersMobile((s) => !s)}
              className="lg:hidden w-full mb-4 bg-white rounded-xl shadow p-4 flex items-center justify-between font-semibold text-[#0D1B3D]"
            >
              <span>☰ Menu</span>
              <span className="text-sm text-gray-400 inline-flex items-center gap-1">
                {showFiltersMobile ? 'Hide' : 'Show'}
                <ChevronDownIcon className={`transition-transform ${showFiltersMobile ? 'rotate-180' : ''}`} />
              </span>
            </button>

            {showFiltersMobile && <EmployerSidebar user={user} activeTab="reports" mobile />}

            <h1 className="text-4xl font-bold mb-2 bg-gradient-to-r from-[#5B2EFF] via-[#8B5CF6] to-[#FF4D8D] bg-clip-text text-transparent">Reports</h1>
            <p className="text-gray-500 mb-8">Pick a category to view detailed analytics.</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {reportCards.map(({ title, description, icon, to, color }) => (
                <Link
                  key={to}
                  to={to}
                  className="group bg-white border border-purple-100 rounded-2xl shadow-sm p-6 transition-all duration-200 hover:bg-gradient-to-r hover:from-[#5B2EFF] hover:via-[#8B5CF6] hover:to-[#FF4D8D] hover:shadow-xl hover:shadow-purple-500/25 hover:-translate-y-0.5"
                >
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 transition-colors group-hover:!bg-white/20 group-hover:!text-white ${color}`}>
                    {icon}
                  </div>
                  <h2 className="text-lg font-bold text-[#0D1B3D] mb-1 group-hover:text-white">
                    {title}
                  </h2>
                  <p className="text-sm text-gray-500 group-hover:text-white/90">{description}</p>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployerReports;